import axios from "axios";

import { apiInterceptor } from "../interceptors/jwt.interceptor";

const API_URL = process.env.REACT_APP_API_SERVER;

export const searchPatient = async (data) => {
  try {
    const { tdoc, doc } = data;
    const response = await apiInterceptor({
      method: 'GET',
      endpoint: `/recu/patient/info?tdoc=${tdoc}&doc=${doc}`,
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
};


export const getPatientDetails = async (id) => {
  try {
    const response = await apiInterceptor({
      method: 'GET',
      endpoint: `/recu/contigo/track/patient/detail/${id}`,
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
}

export const createNewMonitoring = async (data) => {
  try {
    return await apiInterceptor({
      method: 'POST',
      endpoint: '/recu/contigo/start',
      data,
    });
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const updateTrackConsent = async (data) => {
  try {
    return await apiInterceptor({
      method: 'POST',
      endpoint: "/recu/contigo/track/consent",
      data,
    });
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getAlertByPatientId = async (id) => {
  try {
    return await axios.get(`${API_URL}/recovery/track/alerts/${id}`, {
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
    console.error(error);
    return error;
  }
}

export const startTracking = async (data) => {
  try {
    return await axios.post(`${API_URL}/recovery/track/trace`, data, {
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
    console.error(error);
    return error;
  }
}

export const updateAlert = async (data) => {
  try {
    return await axios.put(`${API_URL}/recovery/track/trace`, data, {
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
    console.error(error);
    return error;
  }
}

export const deleteAlert = async (idQuestion, idPlan, remarkId) => {
  try {
    return await apiInterceptor({
      method: "DELETE",
      endpoint: `/recu/contigo/track/trace/${idQuestion}?remark_id=${remarkId}&plan_id=${idPlan}`,
    });
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const updateTrack = async (trackId, data) => {
  try {
    return await await apiInterceptor({
      method: "PUT",
      endpoint: `/recu/contigo/track/${trackId}`,
      data,
    });
  } catch (error) {
    console.error(error);
    return error;
  }
};
